<template>
  <Flex column p-3 text-center>
    <Select
      :items="availableLanguages"
      :value.sync="selectedLanguage"
      :disabled="defaultLanguage"
      class="mb-3"
      :required="true"
    />
    <Flex
      v-for="value in selectedTranslationValues"
      :key="value.id"
      class="input-container"
      pt-1
      pb-1
    >
      <TextField
        :value.sync="value.value"
        :class="{ disabled: defaultLanguage }"
        :disabled="defaultLanguage"
      />
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex.vue'
import TextField from '@wizer/core/components/text-field/TextField.vue'
import Select from '@wizer/core/components/select/Select'

export default {
  name: 'LanguageTranslations',
  components: {
    Flex,
    TextField,
    Select,
  },
  props: {
    defaultLanguage: Boolean,
    availableLanguages: Array,
    lookupData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      selectedLanguage: this.availableLanguages[0].data.value,
    }
  },
  computed: {
    selectedTranslationValues() {
      return this.lookupData.translations.find(
        (translation) => translation.language.id === this.selectedLanguage,
      ).values
    },
  },
}
</script>

<style>
.input-container {
  width: 25em;
}

.w-text-field.disabled .w-text-field__control {
  @apply bg-gray-200;
}
</style>
